module.exports = __webpack_public_path__ + "img/concert_intro_background.4dde43b2.png";